import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Styles from "../../../Styles/HeapMapDrawer.module.css";
import discomService from "../../../components/Services/discom.service";
import {
 CircularProgress,
 Paper,
 Table,
 TableBody,
 TableCell,
 TableContainer,
 TableHead,
 TableRow,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EditEnergyConsumption from "./editEnergyConsumption";

const EnergyConsumptionCurve = ({ isOpen, closeCurveModal }) => {
 const [heatMapData, setHeatMapData] = useState(null);
 const [editCell, setEditCell] = useState(null);

 const getEnergyConsumptionCurve = () => {
  setHeatMapData(null);
  discomService
   .getEnergyConsumptionCurve()
   .then((response) => {
    if (response?.data?.code === 200) {
     setHeatMapData(response?.data?.data);
    }
   })
   .catch((err) => console.log("Api call Error:", err));
 };
 const handleCellEdit = (item, discomId) => {
  setEditCell({ item, discomId });
 };
 const handleCloseEditCellModal = () => {
  setEditCell(null);
 };
 useEffect(() => {
  getEnergyConsumptionCurve();
 }, []);

 return (
  <>
   {editCell && (
    <EditEnergyConsumption
     editCell={editCell}
     handleCloseEditCellModal={handleCloseEditCellModal}
     getEnergyConsumptionCurve={getEnergyConsumptionCurve}
    />
   )}
   <Modal show={isOpen} onHide={closeCurveModal} size="xl">
    <Modal.Header closeButton>
     <Modal.Title>Energy Consumption Curve Across States</Modal.Title>
    </Modal.Header>
    <Modal.Body>
     {heatMapData ? (
      <div className={Styles.modalMainCont}>
       <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table" size="small">
         <TableHead className="table-header" sx={{ color: "#68BBEA" }}>
          <TableRow>
           <TableCell
            align="center"
            sx={{
             background: "#68BBEA",
             borderRight: 1.5,
             borderColor: "whitesmoke",
            }}
           >
            Discom Name
           </TableCell>
           {heatMapData?.headers?.map((header, headerIndex) => (
            <TableCell
             key={headerIndex}
             align="center"
             sx={{
              background: "#68BBEA",
              borderRight: 1.5,
              borderColor: "whitesmoke",
             }}
            >
             {header}
            </TableCell>
           ))}
          </TableRow>
         </TableHead>
         <TableBody>
          {heatMapData?.discoms?.map((discName, i) => (
           <TableRow
            key={i}
            // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
           >
            <TableCell align="center">{discName?.discomName}</TableCell>
            {discName?.heatmaps?.map((ele, index) => (
             <TableCell
              align="center"
              key={index}
              sx={{
               background: ele?.quantity > 0 ? "green" : "red",
               borderRight: 1.5,
               borderColor: "whitesmoke",
              }}
             >
              <div className="d-flex justify-content-around">
               <div>{ele?.quantity}</div>
               {ele?.isCurrent && (
                <div
                 onClick={() => handleCellEdit(ele, discName?.discomId)}
                 className="pointer-event"
                >
                 <EditOutlinedIcon sx={{width:'0.7em'}} />
                </div>
               )}
              </div>
             </TableCell>
            ))}
           </TableRow>
          ))}
         </TableBody>
        </Table>
       </TableContainer>
       <div className="">
        <div style={{ color: "red" }}>* High Demand / Opportunity to sell </div>
        <div style={{ color: "green" }}>* Low Demand / Opportunity to Buy</div>
       </div>
      </div>
     ) : (
      <div className="popup-loader">
       <CircularProgress />
      </div>
     )}
    </Modal.Body>
   </Modal>
  </>
 );
};

export default EnergyConsumptionCurve;
